import { useState } from "react"
import EventCard from "../../components/EventCard"
import rawEvents from "../../data/events.json"
import "./style/Events.scss"

// Define a type matching the allowed statuses
type Event = {
  id: number
  title: string
  date: string
  type: string
  status: "upcoming" | "past"
  location: string
}

// Cast raw data as Event[]
const eventData = rawEvents as Event[]

const About = () => {
  const [activeFilter, setActiveFilter] = useState<"upcoming" | "past">("upcoming")

  const filteredEvents = eventData.filter(
    (event) => event.status === activeFilter
  )

  return (
    <div className="events-page">
      <h1>Crypto Events</h1>

      <div className="event-filters">
        <button
          className={activeFilter === "upcoming" ? "active" : ""}
          onClick={() => setActiveFilter("upcoming")}
        >
          Upcoming
        </button>
        <button
          className={activeFilter === "past" ? "active" : ""}
          onClick={() => setActiveFilter("past")}
        >
          Past Events
        </button>
      </div>

      <div className="events-list">
        {filteredEvents.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </div>
    </div>
  )
}

export default About
